export default __webpack_public_path__ + "static/media/chat.ddd3579e.svg";